export default ({ src }) => <img width="100%" alt="" src={src} />;
